var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.82L10.59 7.41L12 6L6 0L0 6L1.41 7.41L6 2.82ZM0 12.41H12V10.41H0V12.41Z",
    fill: "#6A6C71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaps);
export default __webpack_public_path__ + "static/media/icon-caps.f8565c63184a423aff89761c987d3e40.svg";
export { ForwardRef as ReactComponent };